import { QA_ATTRIBUTES } from '../constants/qaAttributes';
/**
 * @param states - in format { loading: true, disabled: false } or 'loading,disabled' etc
 * @returns {{}}
 */
export const makeQAStates = (states = {}) => {
  const attributes = {};

  if (typeof states === 'string') {
    attributes[QA_ATTRIBUTES.STATES] = states;
  } else if (states) {
    const statesList = [];
    Object.keys(states)
      .forEach(key => {
        if (states[key]) {
          statesList.push(key);
        }
      });
    if (statesList.length) {
      attributes[QA_ATTRIBUTES.STATES] = statesList.join(',');
    }
  }

  return attributes;
};

/**
 * @param tag
 * @param states - in format { loading: true, disabled: false } or 'loading,disabled' etc
 * @returns {{}}
 */
export const makeQAAttributes = (tag, states = {}) => {
  const attributes = {
    ...makeQAStates(states),
  };

  if (tag) {
    attributes[QA_ATTRIBUTES.TAG] = tag;
  }

  return attributes;
};
